/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
/**
 *
 * @export
 * @interface ProjectInUpdate
 */
export interface ProjectInUpdate {
  /**
   *
   * @type {string}
   * @memberof ProjectInUpdate
   */
  name?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof ProjectInUpdate
   */
  deleted?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof ProjectInUpdate
   */
  favorite?: boolean | null;
}

/**
 * Check if a given object implements the ProjectInUpdate interface.
 */
export function instanceOfProjectInUpdate(value: object): value is ProjectInUpdate {
  return true;
}

export function ProjectInUpdateFromJSON(json: any): ProjectInUpdate {
  return ProjectInUpdateFromJSONTyped(json, false);
}

export function ProjectInUpdateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ProjectInUpdate {
  if (json == null) {
    return json;
  }
  return {
    name: json['name'] == null ? undefined : json['name'],
    deleted: json['deleted'] == null ? undefined : json['deleted'],
    favorite: json['favorite'] == null ? undefined : json['favorite']
  };
}

export function ProjectInUpdateToJSON(value?: ProjectInUpdate | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    deleted: value['deleted'],
    favorite: value['favorite']
  };
}
